export default "__VITE_ASSET__Bp7ZLGAZ__"